export class DimensionMetrics {
  public minX: number;
  public maxX: number;

  constructor(minX: number = 0, maxX: number = 0) {
    this.minX = minX;
    this.maxX = maxX;
  }
}
